import { retrieveAndParse, write } from "../../utilities/Utility";
import {
	writePrecursorXMLSingle,
	writePrecursorXMLLines
} from "../../writes/udo";
import { dummy_leads } from "../../mockups/leadtracking_dummy_data";
import svc from 'svc';

export const types = {
	SET_DEFAULT: 'LEADS/SET_DEFAULT',
	SET_ATTRIBUTE_BY_OBJ: 'LEADS/SET_ATTRIBUTE_BY_OBJ',
	ADD_NEW_LEAD: 'LEADS/ADD_NEW_LEAD',
	UPDATE_LEAD: 'LEADS/UPDATE_LEAD',
	SET_STATE: 'LEADS/SET_STATE'
}

const defaultState = {
	editLead: null,
	leads: [],
}

export default (state = defaultState, action) => {
	switch (action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		case types.SET_STATE:
			return Object.assign({}, state, action.newState);
		case types.ADD_NEW_LEAD:
			return Object.assign({}, state, {
				leads: [...state.leads, action.newLead]
			});
		case types.UPDATE_LEAD:
			return Object.assign({}, state, {
				leads: updateObjectInArray(state.leads, action.lead)
			});
		default:
			return state;
	}
}

function updateObjectInArray(leads, action) {
	return leads.map((item) => {
		if (item.companyName !== action.companyName) {
			return item;
		}
		return {
			...action
		};
	});
}

const saveElement = (ele) => {
	const obj = writePrecursorXMLSingle(ele);
	return write(obj);
}

export const actions = {
	setDefault: () => {
		return { type: types.SET_DEFAULT };
	},
	setAttributeByObj: (obj) => {
		return { type: types.SET_ATTRIBUTE_BY_OBJ, obj };
	},
	setState: (newState) => ({ type: types.SET_STATE, newState }),
	getLeadsData: () => {
		return function (dispatch) {
			const readRequest = retrieveAndParse('LeadTracker.GetAllLeads', {});
			readRequest.then((res) => {
				console.log(res);
				dispatch(actions.setState({
					leads: res // DEBUG use dummy_leads
				}))
			})
		};
	},
	addNewLead: (newLead) => {
		svc.send('writeLead', newLead)
		return { type: types.ADD_NEW_LEAD, newLead }
	},
	updateExistingLead: (lead) => {
		svc.send('writeLead', lead)
		return { type: types.UPDATE_LEAD, lead }
	}
}


// WEBPACK FOOTER //
// ./src/redux/leadtracker/leadData.js